import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, styled, Text } from 'shell/components';

const AssignmentImportSection = memo(({ disabled = false, onImport }) => {
    const { t } = useTranslation('assignment');

    return (
        <RootBox>
            <Stack spacing={2}>
                <Text variant={'p2'} weight={'medium'}>
                    {t('assignment-rollover.section-title', 'Import Assignment Settings')}
                </Text>
                <Text color={'light'} variant={'p2'}>
                    {t('assignment-rollover.section-description', 'Reuse settings from another assignment')}
                </Text>
            </Stack>
            <Button disabled={disabled} size={'small'} variant={'primary'} onClick={onImport}>
                {t('common:controls.import', 'Import')}
            </Button>
        </RootBox>
    );
});

const RootBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    borderRadius: '16px',
    padding: theme.spacing(3),
    background: theme.palette.ensightful.primary[50],
    [theme.breakpoints.down('mobile')]: {
        alignItems: 'flex-start',
        flexDirection: 'column',
    },
}));

export default AssignmentImportSection;
